<template>
    <svg class="infoOverlay" :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7.25" :stroke="fill" stroke-width="1.5" fill="none" />
        <rect x="7.25" y="3.5" width="1.5" height="1.5" :fill="fill" />
        <rect x="7.25" y="6" width="1.5" height="6.5" :fill="fill" />
    </svg>
</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default: '#667488',
        },
        width: {
            type: String,
            default: '16',
        },
        height: {
            type: String,
            default: '16',
        }
    }
}
</script>